import React, { useState, useEffect } from 'react';
import { Modal, Button, FormInput, FormSelect, RichTextEditor } from '../../../components/ui';

export default function AddTermInfoModal({ isOpen, onClose, onSave, initialData, isViewOnly }) {
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    description: '',
    paymentTitle: 'PAYMENT DETAILS',
    paymentDescription: '',
    status: 'Active'
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData({
        title: initialData.title || '',
        category: initialData.category || '',
        description: initialData.description || '',
        paymentTitle: initialData.paymentTitle || 'PAYMENT DETAILS',
        paymentDescription: initialData.paymentDescription || '',
        status: initialData.status || 'Active'
      });
    } else {
      setFormData({
        title: '',
        category: '',
        description: '',
        paymentTitle: 'PAYMENT DETAILS',
        paymentDescription: '',
        status: 'Active'
      });
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleRichTextChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isViewOnly) {
      onClose();
      return;
    }
    setLoading(true);
    try {
      const dataToSave = {
        ...formData,
        title: formData.title || 'TERMS AND CONDITIONS',
        paymentTitle: formData.paymentTitle || 'PAYMENT DETAILS',
        category: formData.category || 'General',
      };
      await onSave(dataToSave);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isViewOnly ? "VIEW TERMS AND CONDITIONS" : initialData ? "EDIT TERMS AND CONDITIONS" : "ADD TERMS AND CONDITIONS"}
      size="2xl"
    >
      <form onSubmit={handleSubmit} className="flex flex-col">
        <div className="space-y-6 pb-4">
          <RichTextEditor
            label="TERMS AND CONDITIONS"
            name="description"
            value={formData.description}
            onChange={(value) => handleRichTextChange('description', value)}
            placeholder="Enter term points here (e.g. 1. ...)"
            disabled={isViewOnly}
            minHeight="160px"
          />

          <RichTextEditor
            label="PAYMENT TERMS"
            name="paymentDescription"
            value={formData.paymentDescription}
            onChange={(value) => handleRichTextChange('paymentDescription', value)}
            placeholder="Enter payment points here (e.g. 1. ...)"
            disabled={isViewOnly}
            minHeight="160px"
          />
        </div>

        <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-100 mt-2 shrink-0 bg-white">
          <Button type="button" variant="secondary" onClick={onClose}>
            {isViewOnly ? "Close" : "Cancel"}
          </Button>
          {!isViewOnly && (
            <Button type="submit" loading={loading} variant="orange">
              {initialData ? "Update" : "Save"}
            </Button>
          )}
        </div>
      </form>
    </Modal>
  );
}
